import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserDetails, UserDetailsApi } from 'src/app/shared/models/auth/user';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public empID$: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public isPassUpdate$: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public number$: BehaviorSubject<any> = new BehaviorSubject<any>('');
  constructor(private http: HttpClient) {}

  login(user: string, pass: string, source: any, ip: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/login`, {
      username: user,
      password: pass,
      source,
      ip,
    });
  }

  logOut(param): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/logout`, param);
  }

  logOutFromJobs(param): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/jobs/logout`, param);
  }

  getLoggedData(): Observable<UserDetails[]> {
    console.log('called');
    return this.http
      .get<UserDetailsApi>(`${environment.apiUrl}/get_emp_detail`)
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  OtpSend(id): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/send_otp`, {
      username: id,
    });
  }
  verifyOtp(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/validate_otp`, data);
  }
  changePaswrd(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/change_password_otp`,
      data
    );
  }
  getInternalJobsFilter(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_jobs_filter`);
  }
  getAllRegion(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/select_region`);
  }
  getStateForFilter(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_state_name`);
  }
  getCityForFilter(stId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/jobs/get_city_name/` + stId
    );
  }
  getGenders(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_genders`);
  }
  getIjpMrfsRegular(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_ijp_mrfs`, {
      params: param,
    });
  }
  getIjpMrfsFTC(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }

    // if ('levelID' in data && data.levelID !== '' && data.levelID !== undefined) {
    //   param = param.append('levelID', data.levelID);
    // }

    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_ijp_mrfs_ftc`, {
      params: param,
    });

    // let param = new HttpParams();
    // for (const key in data) {
    //   if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
    //     param = param.append(key, data[key]);
    //   }
    // }
    // return this.http.get<any>(`${environment.apiUrl}/jobs/get_ijp_mrfs_ftc`, {
    //   params: param,
    // });
  }

  getIjpMrfsMoreFTC(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_ijp_mrfs_more_ftc`);
  }

  getJobsCategory(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_jobs_category`);
  }

  getIjpDetails(mrfId: string, user_id: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/jobs/get_ijp_details/` +
        mrfId +
        '?user_id=' +
        user_id
    );
  }
  addCandidateIJP(req, candID): Observable<any[]> {
    if (candID === '' || candID === null || candID === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/jobs/cand_ijp_apply`,
        req
      );
    }
  }
  getEmployeesDetails(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/jobs/get_emp_details_ijp`,
      req
    );
  }
  getDesignation(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/jobs/get_designation`);
  }

  // route Check
  routeCheck(url): Observable<boolean> {
    const subject = new Subject<boolean>();
    this.http
      .post<any>(`${environment.apiUrl}/router_guard`, { route: url })
      .subscribe((res) => {
        subject.next(res);
      });
    return subject.asObservable();
  }

  // auth log

  authLogsGet(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/get_auth_log`, {
      params: param,
    });
  }

  checkConsent(
    user: string,
    pass: string,
    source: any,
    ip: any
  ): Observable<any> {
    return this.http.post(`${environment.apiUrl}/checkConsent`, {
      username: user,
      password: pass,
      source,
      ip,
    });
  }

  verifyConsent(
    user: string,
    pass: string,
    source: any,
    ip: any,
    consent: any
  ): Observable<any> {
    return this.http.post(`${environment.apiUrl}/verifyConsent`, {
      username: user,
      password: pass,
      source,
      ip,
      consent,
    });
  }

  appLogin(appLink): Observable<any> {
    let params = {
      //  : appLink
    }
    for (var i = 0; i < localStorage.length; i++){
        params[localStorage.key(i)] = localStorage.getItem(localStorage.key(i));
    }
    params['app_link'] = appLink;
    return this.http.post<any>(`${environment.apiUrl}/app-login`, params);
  }

  appLoginRedirect(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/fin-login-redirect`, data);
  }

  finLoginRedirect(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/fin-login-redirect`, data);
  }
  
  ssoLoginDetails(data): Observable<any>
  {
   return this.http.get(`${environment.apiUrl}/ssoLoginDetails/${data}`);
  }
 
 
  userIsExt(data): Observable<any>{
   return this.http.get(`${environment.apiUrl}/userIsExt/${data}`)
  }
 
  getSSOToken(data): Observable<any>{
   
   return this.http.get(`${environment.apiUrl}/getssotoken?username=${data}`);
  }

  getIjpMrfsFTCJobs(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/jobs/get_ijp_mrfs_ftc_jobs`, {
      params: param,
    });
  }

  getIjpMrfsLatestJobs(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/jobs/get_ijp_mrfs_latest_jobs`, {
      params: param,
    });
  }

  getIjpDetailsDesc(mrfId: string, user_id: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/jobs/get_ijp_details_desc/` +
        mrfId +
        '?user_id=' +
        user_id
    );
  }
  
}
